// extracted by mini-css-extract-plugin
module.exports = {"actionCard":"ob_sEQICC","actionCard__icon":"ob_tPajDM","actionCard__content":"ob_tSH2zI"};